module.exports = __webpack_public_path__ + "static/img/inboundcycle-logo.078bfe35.png";